import Jumbotron from './Jumbotron';
import p2 from './../components/assets/images/p2.webp';
import p3 from './../components/assets/images/p3.webp';
import p4 from './../components/assets/images/p4.webp';
import p5 from './../components/assets/images/p5.webp';
const images = [
    "http://i1043.photobucket.com/albums/b434/drebrahimi/p2.jpg",
    "http://i1043.photobucket.com/albums/b434/drebrahimi/p3.jpg",
    "http://i1043.photobucket.com/albums/b434/drebrahimi/p4.jpg",
    "http://i1043.photobucket.com/albums/b434/drebrahimi/p5.jpg",
    "http://i1043.photobucket.com/albums/b434/drebrahimi/p6.jpg",
    "http://i1043.photobucket.com/albums/b434/drebrahimi/p7.jpg",
    "http://i1043.photobucket.com/albums/b434/drebrahimi/p8.jpg",
    "http://i1043.photobucket.com/albums/b434/drebrahimi/p9.jpg",
    "http://i1043.photobucket.com/albums/b434/drebrahimi/p10.jpg",
    "http://i1043.photobucket.com/albums/b434/drebrahimi/p11.jpg",
    "http://i1043.photobucket.com/albums/b434/drebrahimi/p12.jpg",
    "http://i1043.photobucket.com/albums/b434/drebrahimi/p13.jpg",
    "http://i1043.photobucket.com/albums/b434/drebrahimi/p15.jpg",
    "http://i1043.photobucket.com/albums/b434/drebrahimi/p16.jpg",
    "http://i1043.photobucket.com/albums/b434/drebrahimi/p17.jpg",
    "http://i1043.photobucket.com/albums/b434/drebrahimi/p18.jpg",
    "http://i1043.photobucket.com/albums/b434/drebrahimi/p19.jpg",
    "http://i1043.photobucket.com/albums/b434/drebrahimi/p20.jpg",
    "http://i1043.photobucket.com/albums/b434/drebrahimi/p21.jpg",
    "http://i1043.photobucket.com/albums/b434/drebrahimi/p22.jpg",
    "http://i1043.photobucket.com/albums/b434/drebrahimi/p23.jpg",
    "http://i1043.photobucket.com/albums/b434/drebrahimi/p24.jpg"
  ];
const Patent = ()=> {
    return ( 
        <>
        <Jumbotron />
        <div className="page-padd mt-4">
        <div className="card">
                <div className="card-header">Patent</div>
                <div className="card-body">
                    <div className="text-center">
                        <a href="https://patents.google.com/patent/US20060179420A1/en" target="_blank" className="btn btn-primary text-white">Link to Current Status via GooglePatents</a>
                    </div>
                  <div className="card-text mb-4">
                    USPTO Final Action<br />
                    Web VPCL (Web Visual Plan Construct Language: a visual system and method for learning and teaching programming and problem solving)
                  </div>
                  <div className="row">
        {images.map((image, index) => (
          <div className="col-md-6 mb-4" key={index}>
            <img src={image} alt={`Patent Image ${index + 1}`} className="img-fluid img-thumbnail p-image" />
          </div>
        ))}
      </div>
                
                </div>
              </div>
            <div className="mt-3">
                <iframe frameBorder="0" height="300" title="myFrame"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3020.3113589675813!2d-73.57774648414325!3d40.79915127932243!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c286b96a1b2727%3A0xad943160e075b92f!2sNew+Academic+Building+at+SUNY+Old+Westbury!5e0!3m2!1sen!2sus!4v1513701666413"
                    className="iframeStyle">
                </iframe>
            </div>
        </div>
        </>
     );
}

export default Patent;